import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { LANGUAGES } from "@/languages/language";
import { useWidgetStore } from "@/stores/widget-store";

export function LanguageSelector() {
  const setLanguage = useWidgetStore((state) => state.setLanguage);
  const defaultLanguage = useWidgetStore((state) => state.config.language.default);
  
  const handleLanguageChange = (language: string) => {
    setLanguage(language);     
  };
  
  return (
    <Select value={defaultLanguage} onValueChange={handleLanguageChange}>
      <SelectTrigger className="cy:w-[296px] cy:rounded cy:py-5.5 cy:shadow-none cy:text-base!">
        <SelectValue placeholder="Select Language" />
      </SelectTrigger>

      <SelectContent className="cy:text-base!">
        <SelectGroup>
          <SelectLabel>Languages</SelectLabel>
          {LANGUAGES.map((lang) => (
            <SelectItem key={lang.code} value={lang.code} className="cy:text-base!">
              {lang.code === defaultLanguage ? (
                <>
                  {lang.label} <span className="cy:text-[#1578F7]">Default</span>
                </>
              ) : (
                lang.label
              )}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
